import moment from "moment";

import type { TranslatorService } from "@app/services/translator";

const getMinutes = (m: number, translator: TranslatorService) => {
  if (m === 0) {
    return "";
  }
  if (m === 1) {
    return `${m} ${translator.t("!itinerary.duration.minute")}`;
  }

  return `${m} ${translator.t("!itinerary.duration.minutes")}`;
};

const getHours = (h: number, translator: TranslatorService) => {
  if (h === 0) {
    return "";
  }
  if (h === 1) {
    return `${h} ${translator.t("!itinerary.duration.hour")}`;
  }

  return `${h} ${translator.t("!itinerary.duration.hours")}`;
};

const getDays = (d: number, translator: TranslatorService) => {
  if (d < 1) {
    return "";
  }

  if (d === 1) {
    return `${d} ${translator.t("!itinerary.duration.day")},`;
  }

  return `${d} ${translator.t("!itinerary.duration.days")},`;
};

// See tests for output
export const getFormattedDuration = (
  duration: moment.Duration,
  translator: TranslatorService
) => {
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();

  const formatted_minutes = getMinutes(minutes, translator);
  const formatted_hours = getHours(hours, translator);
  const formatted_days = getDays(days, translator);

  return [formatted_days, formatted_hours, formatted_minutes]
    .filter(content => !!content)
    .join(" ")
    .replace(/,$/g, "");
};

export const getDuration = (
  date1: moment.MomentInput,
  date2: moment.MomentInput
) => moment.duration(moment(date2).diff(moment(date1)));
